/**
 * AdminRedirect - Redirect admins away from regular routes
 *
 * Redirects platform administrators to the admin layout
 * when they try to access the regular user interface.
 */

import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";
import { ROUTES } from "@/app/routes";

interface AdminRedirectProps {
	children: React.ReactNode;
}

export const AdminRedirect: React.FC<AdminRedirectProps> = ({ children }) => {
	const authContext = useContext(AuthContext);
	const location = useLocation();

	if (!authContext) {
		throw new Error("AdminRedirect must be used within AuthProvider");
	}

	if (
		authContext.isAuthenticated &&
		authContext.tokenManagement.isPlatformAdmin() &&
		!location.pathname.startsWith(ROUTES.ADMIN.ROOT)
	) {
		return <Navigate to={ROUTES.ADMIN.DASHBOARD} replace />;
	}

	return <>{children}</>;
};
